export enum MortalityMatchType {
    Preselects = 1,
    MatchOffer = 2,
    PotentialDonors = 3,
    Rexm = 4   
}